import { applyService } from "@/service"
import { applicationState, providerState, sessionState } from "@/state"
import Action from "@/action/Action"
import { goto } from "@/util/navigation"
import ActionId from "@/action/ActionId"
import SwitchProviderAction from "@/action/actions/SwitchProviderAction"
import Providers from "@/model/provider/Providers.js"
import DynamicProviderKey from "@/model/provider/DynamicProviderKey.js"
import { getReviewPath } from "@/util/plan"

class SelectPaymentPlanAction extends Action {
    #paymentPlan = null
    #financedAmount = null
    #reviewSelection = true
    #selectPaymentPlan = true
    #existingAccountProviderKey = null

    constructor(paymentPlan, financedAmount, reviewSelection = true, selectPaymentPlan = true, existingAccountProviderKey = null) {
        super(ActionId.SELECT_PAYMENT_PLAN)
        this.#paymentPlan = paymentPlan
        this.#financedAmount = financedAmount
        this.#reviewSelection = reviewSelection
        this.#selectPaymentPlan = selectPaymentPlan
        this.#existingAccountProviderKey = existingAccountProviderKey
    }

    async invoke() {
        let promises = []
        if (this.#selectPaymentPlan) {
            promises.push(
                applyService.selectPaymentPlan(this.#paymentPlan.providerKey, {
                    providerPlanCode: this.#paymentPlan.providerPlanCode,
                    financeAmountCents: this.#financedAmount,
                    promotionalName: this.#paymentPlan.promotionalName,
                })
            )
        }

        if (this.#paymentPlan.providerKey !== sessionState.providerKey) {
            promises.push(new SwitchProviderAction(this.#paymentPlan.providerKey, applicationState.applyMode).invoke())
        }

        await Promise.all(promises)

        applicationState.selectedPaymentPlan = this.#paymentPlan
        applicationState.application.selectedOffer = {
            ...(applicationState.selectedOffer || {}),
            providerKey: this.#paymentPlan.providerKey,
            paymentPlanCode: this.#paymentPlan.providerPlanCode,
            paymentPlanId: this.#paymentPlan.providerPlanId,
        }
        const selectedPlanProviderInfo = Providers[DynamicProviderKey.extractProviderKey(this.#paymentPlan.providerKey)]
        if (
            selectedPlanProviderInfo.canFinishWithExistingAccount &&
            this.#existingAccountProviderKey === this.#paymentPlan.providerKey &&
            selectedPlanProviderInfo.providerProductType === this.#paymentPlan.providerProductType
        ) {
            await goto({
                path: `/providers/${this.#paymentPlan.providerKey}/finishWithExistingAccount`,
            })
        } else if (this.#reviewSelection) {
            const reviewPath = getReviewPath(this.#paymentPlan)
            await goto({
                path: `/providers/${this.#paymentPlan.providerKey}/${reviewPath}`,
                query: {
                    mpf: providerState.getProviderProperties(this.#paymentPlan.providerKey).employmentPayDetailsEnabled,
                },
            })
        }
    }
}

export default SelectPaymentPlanAction
